import * as React from 'react';
import { ProspectUserPreference } from '../../api/ProspectUserProfile';
import FormSelectLabeled from './form/SelectLabeled';
import FormInput from './form/Input';
import FormDatePicker from './form/DatePicker';
import { PreferredTourFormat } from '../../utilities/Enums';
import AdditionalResidentsSection from './AdditionalResidentsSection';

interface Props {
    preferences: ProspectUserPreference;
    setPreferences: (preferences: ProspectUserPreference) => void;
    gatherPetInformation?: boolean;
    gatherDesiredLeaseLength?: boolean;
    petPolicyHelp?: string;
    moveInDateError?: string;
}

const petOptions = [
    { value: false, label: "No, I don't have any pets" },
    { value: true, label: 'Yes, I have pets' }
];

export const allTourTypeOptions = [
    { value: PreferredTourFormat.SelfGuided, label: 'Self-guided Tour' },
    { value: PreferredTourFormat.Virtual, label: 'Virtual Tour' }
];

const PreferencesInputs = (props: Props) => {
    let requestPet =
        props.gatherPetInformation !== false ? (
            <FormSelectLabeled
                selectProps={{
                    id: 'pet',
                    name: 'pet',
                    value: props.preferences.pet,
                    required: props.gatherPetInformation === true,
                    placeholder: 'Select pet option...'
                }}
                labelProps={{
                    labelText: 'Pets',
                    invalidText: 'Please select a pet option'
                }}
                helpTextProps={
                    (props.petPolicyHelp && {
                        helpText: props.petPolicyHelp
                    }) ||
                    undefined
                }
                selectOptions={petOptions}
                onChange={(_name, value) =>
                    props.setPreferences({ ...props.preferences, pet: !!value })
                }
            />
        ) : null;

    let requestDesiredLeaseLength =
        props.gatherDesiredLeaseLength !== false ? (
            <FormInput
                inputProps={{
                    id: 'desired-lease-length',
                    name: 'desiredLeaseLength',
                    value: props.preferences.desiredLeaseLength
                        ? props.preferences.desiredLeaseLength.toString()
                        : undefined,
                    required: props.gatherDesiredLeaseLength === true,
                    pattern: '[0-9]+',
                    placeholder: 'Enter Lease Term Length',
                    maxLength: 3
                }}
                labelProps={{
                    labelText: 'Desired Lease Length (months)',
                    invalidText: 'Enter your desired lease length in months'
                }}
                onChange={(_name, value) =>
                    props.setPreferences({
                        ...props.preferences,
                        desiredLeaseLength:
                            typeof value === 'number'
                                ? value
                                : typeof value === 'string'
                                    ? parseInt(value, 10)
                                    : 0
                    })
                }
            />
        ) : null;

    return (
        <div>
            <FormDatePicker
                inputProps={{
                    id: 'move-in-date',
                    name: 'moveInDate',
                    value: props.preferences.desiredMoveInDate,
                    required: true
                }}
                labelProps={{
                    labelText: 'Desired move-in date',
                    invalidText: props.moveInDateError || 'Please select a valid date'
                }}
                invalid={!!props.moveInDateError}
                onChange={(_name, value) =>
                    props.setPreferences({
                        ...props.preferences,
                        desiredMoveInDate: value.toString()
                    })
                }
            />

            {requestDesiredLeaseLength}

            {requestPet}

            <AdditionalResidentsSection
                additionalResidents={props.preferences.additionalResidents}
                onResidentsChange={residents =>
                    props.setPreferences({ ...props.preferences, additionalResidents: residents })
                }
            />
        </div>
    );
};

export default PreferencesInputs;



// WEBPACK FOOTER //
// ./src/components/common/PreferencesInputs.tsx